import React from 'react';
import { AddWatcherModal } from './AddWatcherModal';
import { Connect, PropsFromRedux } from './DecisionWatcherButtonContainer';
import { trackAddDecisionWatcher } from '../../search-utils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../user/user.types';
import { withUser } from '../../../user/UserContext';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import {
  createWatcherRequest,
  deleteWatcherRequest,
} from '../../../watchers/watchers.api';
import {
  sendWatcherDeletedEvent,
  sendWatcherCreatedEvent,
} from '../../../watchers/WatchersUtils';
import { getNewWatcherQueryParams } from './searchWatcherUtils';

type Props = {
  children: (params: {
    createWatcher: () => void;
    isWatched: boolean;
    deleteWatcher: () => void;
  }) => React.ReactNode;
  source: string;
} & PropsFromRedux &
  UserContextType &
  WithRestrictedModalProps &
  WithModalProps;

export class RawDecisionWatcherButton extends React.Component<Props> {
  isMounted = false;

  onCreateWatcher = async () => {
    const { source, queryParams, updateWatcherExists } = this.props;
    try {
      const watcherKey = (
        await createWatcherRequest(getNewWatcherQueryParams(queryParams))
      ).key;
      sendWatcherCreatedEvent({
        key: watcherKey,
        source,
        reportOriginalQueryKey: true,
      });
      updateWatcherExists({
        key: watcherKey,
        alreadyExists: true,
      });
    } catch (error) {
      throw error;
    }
  };

  createWatcher = () => {
    const {
      accessPremium,
      source,
      openRestrictedModal,
      openModal,
      queryParams,
      tags,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal(source);
    } else {
      trackAddDecisionWatcher(source);
      openModal(modalProps => (
        <AddWatcherModal
          queryParams={queryParams}
          tags={tags}
          onCreate={this.onCreateWatcher}
          {...modalProps}
        />
      ));
    }
  };

  deleteWatcher = async () => {
    const {
      source,
      accessPremium,
      openRestrictedModal,
      updateWatcherExists,
    } = this.props;

    if (!accessPremium) {
      openRestrictedModal(source);
    } else {
      try {
        const { key: watcherKey } = this.props.watcherExists;
        if (watcherKey) {
          await deleteWatcherRequest(watcherKey);
          sendWatcherDeletedEvent({
            key: watcherKey,
            source,
          });
          updateWatcherExists({
            key: '',
            alreadyExists: false,
          });
        }
      } catch (error) {
        throw error;
      }
    }
  };

  render() {
    const { children } = this.props;
    const { alreadyExists } = this.props.watcherExists;

    return children({
      createWatcher: this.createWatcher,
      isWatched: alreadyExists,
      deleteWatcher: this.deleteWatcher,
    });
  }
}

export const DecisionWatcherButton = withModal(
  withUser(withRestrictedModal(Connect(RawDecisionWatcherButton))),
);
